<template>
  <v-app id="inspire">
    <CoreHeader />

    <v-navigation-drawer
      ref="globalNavDrawer"
      v-model="drawer"
      app
      clipped
      class="global-nav-drawer"
      :width="globalNavDrawerWidth"
    >
      <v-list dense>
        <div v-for="(section, index) in menuItems" :key="`section-${index}`">
          <v-divider v-if="index > 0" :key="`divider-${index}`" class="gray" />
          <v-list-item :key="`title-${index}`" class="font-weight-bold">
            {{ section.title }}
          </v-list-item>
          <v-list-item v-for="item in section.items" :key="item.to" :to="item.to">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title style="font-weight: 700">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container
        fluid
        class="pa-0 w-100 admin-crud-fit-host"
        style="height: calc(100vh - var(--footerHeight) - var(--toolbarHeight))"
      >
        <router-view />
      </v-container>

      <ProgressDialog />
      <AdminAlertBar />
    </v-main>
    <CoreFooter />
    <GlobalAlert />
  </v-app>
</template>

<script>
  import ProgressDialog from '@/components/dialog/ProgressDialog';
  import AdminAlertBar from '@/components/snackbar/AdminAlertBar';
  import GlobalAlert from '@/components/common/GlobalAlert.vue';
  import { mapGetters } from 'vuex';
  import { globalNavDrawerResizeMixin } from '@/ui/mixins/globalNavDrawerResizeMixin.js';

  export default {
    name: 'AdminPage',
    mixins: [globalNavDrawerResizeMixin],
    components: {
      AdminAlertBar,
      ProgressDialog,
      GlobalAlert,
      CoreHeader: () => import('../../components/core/CoreHeader.vue'),
      CoreFooter: () => import('../../components/core/CoreFooter.vue')
    },
    data: () => ({
      drawer: true,
      drawerRight: false,
      right: true,
      left: true
    }),
    computed: {
      ...mapGetters({ userProfile: 'user/getUserProfile' }),
      menuItems() {
        const isAdmin = this.userProfile?.userRole === 'ADMIN';
        const isUser = this.userProfile?.userRole === 'USER';

        return [
          {
            title: this.$t('adminNav.projectSection'),
            items: [
              {
                title: this.$t('adminNav.project'),
                to: '/admin/project',
                icon: 'mdi-projector-screen-outline',
                show: isAdmin
              },
              {
                title: this.$t('adminNav.site'),
                to: '/admin/sites',
                icon: 'mdi-solar-panel',
                show: isAdmin
              },
              {
                title: this.$t('adminNav.report'),
                to: '/admin/solar-module-report',
                icon: 'mdi-calendar-search-outline',
                show: isAdmin
              },
              {
                title: this.$t('adminNav.aiAnalysis'),
                to: '/admin/ai-analysis',
                icon: 'mdi-robot-outline',
                show: isAdmin
              }
            ].filter(item => item.show)
          },
          {
            title: this.$t('adminNav.customerSection'),
            items: [
              {
                title: this.$t('adminNav.company'),
                to: '/admin/companies',
                icon: 'mdi-domain',
                show: isAdmin
              },
              {
                title: this.$t('adminNav.companyManager'),
                to: '/admin/company-managers',
                icon: 'mdi-account-supervisor',
                show: isAdmin
              }
            ].filter(item => item.show)
          },
          {
            title: this.$t('adminNav.operatorSection'),
            items: [
              {
                title: this.$t('adminNav.userAccount'),
                to: '/admin/users',
                icon: 'mdi-account-search',
                show: isAdmin || isUser
              }
            ].filter(item => item.show)
          },
          {
            title: this.$t('adminNav.panelSection'),
            items: [
              {
                title: this.$t('adminNav.panelPlanning'),
                to: '/admin/panel-planning',
                icon: 'mdi-view-grid',
                show: isAdmin
              },
              {
                title: this.$t('adminNav.panelProduct'),
                to: '/admin/panel-products',
                icon: 'mdi-solar-panel',
                show: isAdmin
              }
            ].filter(item => item.show)
          },
          {
            title: this.$t('adminNav.imageSection'),
            items: [
              {
                title: this.$t('adminNav.thermalAlignment'),
                to: '/admin/image-alignment',
                icon: 'mdi-image-multiple',
                show: isAdmin
              }
            ].filter(item => item.show)
          }
        ].filter(section => section.items.length > 0);
      }
    },
    created() {
      this.$eventBus.$on('toggle-drawer', this.onToggleDrawerEvent);
      this.applyGlobalDrawerForRoute(this.$route);
    },
    watch: {
      $route(to) {
        this.applyGlobalDrawerForRoute(to);
      }
    },
    beforeUnmount() {
      this.$eventBus.$off('toggle-drawer', this.onToggleDrawerEvent);
    },
    mounted() {
      if (this.userProfile?.userRole !== 'ADMIN') {
        this.$router.push({ path: '/dashboard' });
      }
      this.$nextTick(() => {
        this.initGlobalNavDrawerResize();
      });
    },
    methods: {
      applyGlobalDrawerForRoute(route) {
        if (route?.name === 'admin-panel-planning') {
          this.drawer = false;
        }
      },
      onToggleDrawerEvent({ from }) {
        if (from === 'HeaderBar') {
          this.drawer = !this.drawer;
        }
      },
      logout() {
        this.$router.push({ path: 'login' });
      }
    }
  };
</script>

<style>
  .solra_title {
    color: #000000;
  }
  /* .header_color {
	background-color: #ffffff;
} */

  .v-data-table >>> th {
    font-weight: 700 !important;
  }
</style>
